<style lang="stylus">
.step-text {
  padding: 16px;
  font-size: 18px;
}

.bold-text {
  font-weight: 600;
  color: #2A2A2A;
}

.light-text {
  color: #747474;
  font-weight: 400;
}

.bold-icon {
  color: #2A2A2A !important;
}

.yellowCircle-idVerify {
  color: rgb(51, 49, 48);
  background-color: #ffc527;
  border: 2px solid #ffc527;
  border-radius: 50%;
  padding: 2.71px 9.45px 2.8px 9.5px;
  margin-right: 10px;
  font-weight: bold;
  font-size: 21px;
}

.yellowCircle3-idVerify {
  border: 2px solid #DDDDDD;
  color: #b7b7b7;
  background-color: white;
  border-radius: 50%;
  padding: 2.71px 9.45px 2.8px 9.5px;
  margin-right: 10px;
  font-weight: bold;
  font-size: 21px;
}

.step-1-div {
  width: 100%;
  position: relative;
}

.step-1-div:after {
  content: '';
  width: 100%;
  border-bottom: solid 2px #A2A2A2;
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 0;
}

.increase-z-index {
  position: relative;
  z-index: 1;
}

.user-portrait {
  background-image: url('../assets/icons/userphoto-icon.png');
  width: 54px;
  height: 44px;
}

@media (max-width: 1024px) {
  .step-1-div {
    margin-bottom: 16px;
  }

  .step-3-div {
    margin-bottom: 16px;
  }
}

@media (max-width: 600px) {
  .mobile-icons {
    width: 36px;
    height: 29.3px;
  }

  .step-1-div {
    width: auto;
  }
}
</style>
<template>
  <div>
    <v-row wrap>
      <v-col cols="4" md="4" style="text-align: center">
        <div class="step-1-div">
          <span class="yellowCircle-idVerify increase-z-index" v-if="step == 1">1</span>
          <v-icon
            class="increase-z-index"
            color="#A2A2A2"
            width="35px"
            height="35px"
            style="font-size: 35px; margin-bottom: -7px; background: white"
            v-if="step > 1"
            >mdi-check-circle</v-icon
          >
        </div>
        <div class="step-text d-none d-md-flex justify-center" :class="step == 1 ? 'bold-text' : 'light-text'">
          Take your photo
        </div>
        <img
          src="../assets/icons/user-photo-icon-dark.svg"
          :style="{ filter: step > 1 ? 'brightness(4)' : '' }"
          class="mobile-icons"
          alt
        />
      </v-col>
      <v-col cols="4" md="4" style="text-align: center">
        <div class="step-1-div">
          <span
            class="yellowCircle-idVerify increase-z-index"
            style="color: #a2a2a2; border-color: #dddddd; background-color: white"
            v-if="step < 2"
            >2</span
          >
          <span
            class="yellowCircle3-idVerify increase-z-index"
            style="background-color: #ffc527; color: black; border: 2px solid #ffc527"
            v-if="step == 2"
            >2</span
          >
          <v-icon
            class="increase-z-index"
            color="#A2A2A2"
            width="35px"
            height="35px"
            style="margin-bottom: -7px; font-size: 35px; background: white"
            v-if="step > 2"
            >mdi-check-circle</v-icon
          >
        </div>
        <div class="step-text d-none d-md-flex justify-center" :class="step == 2 ? 'bold-text' : 'light-text'">
          Take a photo of your ID
        </div>

        <img
          src="../assets/icons/id-icon-grey.svg"
          class="mobile-icons"
          :style="{ filter: step != 2 ? '' : 'brightness(0.4)' }"
        />
      </v-col>

      <v-col cols="4" md="4" style="text-align: center">
        <div class="step-3-div">
          <span class="yellowCircle3-idVerify increase-z-index" v-if="step < 3">3</span>
          <span class="yellowCircle-idVerify increase-z-index" v-if="step == 3">3</span>
        </div>
        <div class="step-text d-none d-md-flex justify-center" :class="step == 3 ? 'bold-text' : 'light-text'">
          Review and submit
        </div>
        <img
          src="../assets/icons/click-icon-grey.svg"
          class="mobile-icons"
          :style="{ filter: step != 3 ? '' : 'brightness(0.4)' }"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  data() {
    return {};
  },

  props: {
    step: {
      type: Number
    }
  }
});
</script>
